import { useState, useEffect, type ReactNode } from 'react';
import { ThemeProvider } from '@kollektive/design-system';
import { AppSidebar } from './AppSidebar';
import { OnboardingWizard } from './onboarding';
import { useOnboarding } from '@/hooks/useOnboarding';
import styles from './AppLayout.module.css';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { showOnboarding, isLoading } = useOnboarding();
  const [showWizard, setShowWizard] = useState(false);

  // Show wizard when onboarding status indicates it should be shown
  useEffect(() => {
    if (!isLoading && showOnboarding) {
      setShowWizard(true);
    }
  }, [isLoading, showOnboarding]);

  const handleCloseWizard = () => {
    setShowWizard(false);
  };

  return (
    <ThemeProvider defaultTheme="dark">
      <div className={styles.layout}>
        <AppSidebar />
        <main className={styles.main}>
          {children}
        </main>
        {showWizard && <OnboardingWizard onClose={handleCloseWizard} />}
      </div>
    </ThemeProvider>
  );
}
